import React from 'react'
export default function Settings() {
  return <div className="bg-gray-800 rounded-xl shadow-lg p-6 border border-gray-700"><h2 className="text-2xl font-bold text-white">Settings</h2><p className="text-gray-400 mt-2">Configure your preferences and API keys.</p></div>
}
